(() => {
  if (window.OremLocationAcknowledgmentInitialized) return;
  window.OremLocationAcknowledgmentInitialized = true;

  const checkboxSelector = '[data-orem-location-checkbox]';
  const checkoutSelector = '#checkout, #CartDrawer-Checkout';
  let saving = false;

  function getChecked() {
    return [...document.querySelectorAll(checkboxSelector)].some((checkbox) => checkbox.checked);
  }

  function syncControls(showError = false) {
    const checked = getChecked();
    document.querySelectorAll(checkboxSelector).forEach((checkbox) => {
      checkbox.checked = checked;
    });
    document.querySelectorAll(checkoutSelector).forEach((button) => {
      button.disabled = !checked;
      button.setAttribute('aria-disabled', String(!checked));
    });
    document.querySelectorAll('#main-cart-footer .additional-checkout-buttons').forEach((container) => {
      container.hidden = !checked;
    });
    document.querySelectorAll('[data-orem-location-error]').forEach((error) => {
      error.hidden = checked || !showError;
    });
    return checked;
  }

  async function saveAttribute(checked) {
    if (saving) return;
    saving = true;
    try {
      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { 'Orem location acknowledged': checked ? 'Yes' : '' },
        }),
      });
    } finally {
      saving = false;
    }
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches(checkboxSelector)) return;
    const checked = event.target.checked;
    document.querySelectorAll(checkboxSelector).forEach((checkbox) => {
      checkbox.checked = checked;
    });
    syncControls();
    saveAttribute(checked);
  });

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest(checkoutSelector);
    if (!checkout || syncControls(true)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    document.querySelector(checkboxSelector)?.focus();
  }, true);

  const observer = new MutationObserver(() => syncControls());
  observer.observe(document.documentElement, { childList: true, subtree: true });
  syncControls();
})();
